import React, { forwardRef } from 'react';
import { Link, useLocation } from 'react-router-dom';

/** Open organization settings over this route without losing its current state. */
export default forwardRef(function OrganizationLink(props, ref) {
  const location = useLocation();
  // MUI may infer role="button" before this component supplies its destination.
  return <Link {...props} role={props.role === 'menuitem' ? 'menuitem' : 'link'} ref={ref} to="/organization" state={{ organizationBackground: location }} />;
});
